<template>
  <div class="container bottom">
    <div class="header bottom-shadow">
      <label v-show="publicId != ''">Share your route!</label>
      <label v-show="publicId == ''">Creating Route</label>
    </div>

    <div class="mid-container">

      <div style="display:flex; justify-content: center; align-items: center; flex-direction: column;">
        <div class="loader" style="margin-top: 20px;padding:20px;" v-bind:class="{ 'loader-hide' : publicId != '' }"></div>
      </div>

      <div v-show="publicId != '' " class="input-container">
        <p>Route created succesfully.</p>
        <p>Share this link with your friends.</p>
        <input :value="link" type="text" id="link" readonly></input>
        <p>You can find the link and further instructions in the email we just sent you.</p>
        <div class="images">
          <div class="image-container">
            <img :src="copy" v-on:click="copyLink()"/>
            <label v-if="copyPressed === false">Copy link</label>
            <label v-else>Link copied</label>
          </div>

          <div class="image-container">
            <!--
            <img :src="share" v-on:click="shareRace()"/>
            <label>Share</label>
            -->
          </div>

        </div>
      </div>
    </div>

  <BottomNav @nextPage="nextPage()" pColor="blue" nText="Finish" nColor="blue" done="true" />

  </div>
</template>

<script>

import BottomNav from './BottomNav'

import { store } from '../store/store'
import { mapState, mapGetters } from 'vuex'

 export default {
   name: 'done',
   title: 'Runner - Done',
   data() {
     return {
       password: '',
       copy: require('../img/copy.svg'),
       share: require('../img/share.svg'),
       copyPressed: false
     }
   },
   components: {
     BottomNav
   },
   computed: {
     ...mapState({
       selectedRouteId: state => state.selectedRouteId
     }),
     ...mapGetters(['publicId']),
     isEmpty() {
       const value = this.publicId != '' ? true : false
       console.log("returning value: ")
       console.log(value)
       return value
     },
     link() {
       return "https://friends.racepeps.com/#/races/" + this.publicId
     }
   },

   mounted() {
     console.log("publidId: ")
     console.log(this.publicId)

     if(this.publicId == '') {
       console.log("tyhjä")
     } else {
       console.log("ei tyhjä")
     }
   },
   methods: {
     previousPage() {
       this.$router.replace('eventkey')
     },
     nextPage() {
       //Publish the route and mark it done, go back to the beginning
       if(this.publicId != '') {
         this.$router.replace('myraces')
         console.log("done")
       } else {
         console.log('was still loading')
       }
     },
     /*copyLink() {
       console.log("copy link")
       const copyText = document.getElementById("link");
       copyText.select();
       document.execCommand("copy");
       this.copyPressed = true;
     },*/
     copyLink() {
       console.log("copylink")
        var el = document.getElementById("link");

        if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
          var editable = el.contentEditable;
          var readOnly = el.readOnly;
          el.contentEditable = true;
          el.readOnly = false;
          var range = document.createRange();
          range.selectNodeContents(el);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          el.setSelectionRange(0, 999999);
          el.contentEditable = editable;
          el.readOnly = readOnly;
        } else {
          el.select();
        }
        document.execCommand('copy');
        el.blur();
        this.copyPressed = true;
     },
     shareRace() {
       console.log("share")
     },
   },


 }
</script>

<style lang="scss" scoped>

  @import '../styles/styles.scss';

  .mid-container {
    padding: 10%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    flex: 9;

    input {
      text-align: center;
    }

  }

  .input-container {
    p {
      text-align: center;
      margin-top: 0px;
      margin-bottom: 5px;
    }

    input {
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }

  .images {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 2%;

    img {
  		width: 50px;
  		height: 50px;
  		margin: 0px;
  		cursor: pointer;
  	}

  }

  .images .image-container {
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 15px;
    margin-right: 15px;
  }

  @media screen and (min-width: 1140px) {
    .container.bottom {
      width: 600px;
      height: 400px;
    }

    .bottom-container {
      margin: 0px;
    }

    .mid-container {
      padding: 1% 15% 1%;
      justify-content: center;

      label {
        align-self: center;
      }
    }
  }

</style>
